import React from 'react'
import './App.scss'

import autobind from './lib/autobind'
import { inject, observer, Provider } from 'mobx-react'
import { get } from 'lodash'

import PageHelmet from '../src/components/PageHelmet'
import Footer from '../src/components/Footer'
import GridToggle from '../src/components/GridToggle'
import Header from '../src/components/Header'
import stores from './stores'
import LoginStore from './stores/Login'
import FAAForm from '../src/components/FAAForm'
import CheckSession from './components/CheckSession'
import { Inactivity } from './components/Inactivity'
import OGLogo from './assets/img/og-logo.jpg'

class App extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = { user: null }

    autobind(this, ['handleLogin', 'handleLogout'])

    if (!process.env || process.env.NODE_ENV === 'development') {
      window.env = {}
      Object.getOwnPropertyNames(process.env)
        .forEach((name) => {
          if (name === 'KEEPALIVE_TIMEOUT' || name.startsWith('REACT_APP_')) {
            window.env[name] = process.env[name]
          }
        })
    }
  }

  componentDidMount () {
    if (typeof window !== 'undefined' && window.__PRELOADED_DATA__) {
      delete window.__PRELOADED_DATA__
    }
    LoginStore.setReturnTo(get(this, 'props.location.query.returnto'))
  }

  componentDidUpdate () {
    this.announcePageTitle(this.announcer)
  }

  /**
   * update js-page-announcer inner text to announce the page title for screen readers
   *
   * @public
   */
  announcePageTitle (target) {
    const title = get(document, 'title')

    if (target && title) {
      target.innerText = title
    }
  }

  shouldShowLogin () {
    return !!get(this, 'props.location.query.login')
  }

  render () {
    const Faa = inject('sessionStore')(observer(({ sessionStore }) => {
      return (
        <div>
          <div className='page-announcer js-page-announcer' ref={(announcer) => { this.announcer = announcer }} aria-live='polite' />
          <PageHelmet
            title='A World-Leading Molecular Insights Company'
            description='Foundation Medicine is a world-leading molecular insights company, connecting physicians, patients and biopharma partners to the latest insights in cancer genomics. is leading a transformation in cancer care, where each patient’s treatment is informed by a deep understanding of the molecular changes that contribute to their disease.'
            image={OGLogo}
            ogType='website'
            ogSite_name='Foundation Medicine'
            ogLocale='en_US'
            twitterSite='@FoundationATCG'
            twitterCard='summary'
          />
          <GridToggle />
          {sessionStore.isLoggedIn && <Inactivity />}
          <Header />
          <div id='main-content' tabIndex='-1' className='main'>
            <FAAForm />
          </div>
          <Footer />
        </div>
      )
    }))

    return (
      <Provider {...stores}>
        <CheckSession>
          <Faa />
        </CheckSession>
      </Provider>
    )
  }
}

export default App
